import type { AtLeastOne } from './'

export type TypeSize = {
  width: number
  height: number
}

type CMSVariantNameTypes = 's' | 'm' | 'l' | 'xl'
export type TypeCmsMediumVariant = {
  src: string
  size: TypeSize
  contentType?: TypeImagesContentType
}


export type TypeCmsImageVariants = {
  [key in CMSVariantNameTypes]?: TypeCmsMediumVariant
}

type TypeImagesContentType = 'image/apng' | 'image/avif' | 'image/gif' | 'image/jpeg' | 'image/png' | 'image/webp'

export type TypeCmsImage = {
  alt: string
  contentType?: TypeImagesContentType
} & AtLeastOne<TypeCmsImageVariants>


enum EnumCMSMediumStatus {
  pending = 'pending',
  processing = 'processing',
  processed = 'processed'
}

export type TypeCmsMedium = {
  id: number
  status?: EnumCMSMediumStatus
  image: TypeCmsImage
}

export type TypeCmsVideo = {
  type: 'video'
  alt: string
  platform: EnumCMSVideoPlatform
  shortVideo?: string
  longVideo: string
}

export type TypeCmsVideoLocal = {
  src: string
  alt: string
}

export enum EnumCMSVideoPlatform {
  vimeo = 'vimeo',
  youtube = 'youtube'
}
